import { useCallback, useContext } from 'react';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import useLead from './useLead';
import { Lead } from 'models/Lead';

export default function useLeads() {
  const {
    currentUser: { _id: currentUserId },
  } = useContext(CurrentUserContext);

  const { getIsNew } = useLead();

  const getNewLeads = useCallback(
    (leads: Lead[]) =>
      leads.filter(getIsNew).map(({ brokerViewIds, ...rest }) => ({
        ...rest,
        brokerViewIds: [...brokerViewIds, currentUserId],
      })),
    [currentUserId, getIsNew],
  );

  return { getNewLeads };
}
